import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment'
import { Anomaly } from "../constant/anomaly"
import { retry, catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class AnomalyService {

  public apiUrl = environment.api

  constructor(
    private httpClient: HttpClient
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json'
    })
  }

  /**
   * getAnomalies
   */
  public getAnomalies(): Observable<Anomaly> {
    return this.httpClient.get<Anomaly>(
      this.apiUrl + 'anomalies/getAll',
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * addAnomaly
   */
  public addAnomaly(data): Observable<Anomaly> {
    return this.httpClient.post<Anomaly>(
      this.apiUrl + 'anomalies/add',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * getAnomaliesByEntreprise
   */
  public getAnomaliesByEntreprise(data): Observable<Anomaly> {
    return this.httpClient.post<Anomaly>(
      this.apiUrl + 'anomalies/getAllByEntreprise',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * updateAnomaly
   */
  public updateAnomaly(data): Observable<Anomaly> {
    return this.httpClient.post<Anomaly>(
      this.apiUrl + 'anomalies/update',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  /**
   * deleteAnomaly
   */
  public deleteAnomaly(data): Observable<Anomaly> {
    return this.httpClient.post<Anomaly>(
      this.apiUrl + 'anomalies/delete',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  // Error handling
  public handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(['Erreur HTTP', errorMessage]);
    return throwError(errorMessage);
  }
}
